import React from 'react';
import Portal from 'new/elements/Portal';
import { LinearProgress } from '@mui/material';
import Typography from 'new/elements/Typography';

import s from './ConnectionLoader.module.scss';

interface Props {
  loading: boolean;
  message: string;
}

export const ConnectionLoader = (props: Props) => {
  const { loading, message } = props;

  if (!loading) return null;

  return (
    <Portal>
      <div className={s.loader}>
        <div className={s.messageContainer}>
          {message ? <Typography>{message}</Typography> : null}
          <LinearProgress />
        </div>
      </div>
    </Portal>
  );
};
